import Switcher from '@/views/switcher';

$(document).on('turbolinks:load', () => {
  const node = document.querySelector('article.how_to_choose_box');
  if (!node) { return; }

  new Switcher('article.how_to_choose_box .tabs');
});
